<template>
  <app-main>
    <app-header slot="header" color="is-default" :is_display_down="false"></app-header>
    <div class="FamousContent">
      <FamousHeader></FamousHeader>
      <div class="applyEnter">
        <div class="applyInformation">
          <div class="applyInformationList">
            <div class="applyName">
              <div class="applyInputText">姓名/艺名：</div>
              <input type="text" placeholder="请填写您的姓名或艺名" value="inputName" v-model="inputName" />
            </div>
            <div class="applyVerification">
              <div class="applyInputText">职称/称号：</div>
              <input type="text" placeholder="请填写您的职称或称号" v-model="inputVerification" />
            </div>
            <div class="applyPhone">
              <div class="applyInputText">电 话：</div>
              <input type="text" placeholder="请填写您的电话 " v-model="inputPhone" />
            </div>
            <div class="applyArt">
              <div class="applyInputText">艺术成就：</div>
              <div class="applyArtTextBox">
                <textarea
                  class="applyArtText"
                  maxlength="800"
                  v-model="textareaValue"
                  placeholder="请输入您的艺术成就"
                  value="textareaValue"
                ></textarea>
                <div class="textNumber">{{textareaValue.length}}/800</div>
              </div>
            </div>
            <div class="applyPhoto">
              <div class="applyInputText">上传个人照片</div>
              <div class="PhotoList">
                <div class="PhotoItem" v-if="photoImgList">
                  <img :src="photoImgList" alt />
                </div>

                <div class="addPhoto">
                  <div class="photoImg">
                    <img src="../../assets/images/famous/ic_camera.png" alt />
                  </div>
                  <div class="photoText">上传图片</div>
                  <input
                    class="filePrew"
                    accept="image/*"
                    type="file"
                    @change="addPhoto()"
                    ref="photoimg"
                  />
                </div>
              </div>
            </div>
            <div class="applyProduction">
              <div class="applyInputText">上传个人代表作</div>
              <div class="mail">
                <div class="mailText">作品文件较大可发至邮箱1183927839@qq.com</div>
                <div class="sj"></div>
              </div>
              <div class="ProductionList">
                <div class="ProductionItem" v-for="(item,index) in ProductionImgList">
                  <img :src="item" alt />
                  <div class="remove" @click="remove(index)">
                    <img src="../../assets/images/famous/ic_delete.png" alt />
                  </div>
                </div>
                <div class="addProduction">
                  <div class="ProductionImg">
                    <img src="../../assets/images/famous/ic_camera.png" alt />
                  </div>
                  <input
                    class="filePrew"
                    accept="image/*"
                    type="file"
                    @change="addProduction()"
                    ref="Productionimg"
                  />
                  <div class="ProductionText">
                    <p>上传图片</p>
                    <p>(最多9张)</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="contacts">
        <div class="contactsText">
          <p>联系人：缪玥</p>
          <p>联系电话：13732708381（微信同号）</p>
        </div>
      </div>
      <div class="submit" @click="submit">提交</div>
      <div class="goDown" v-show="isshow">
        <div class="Downtext">
          <p>您已成功提交资料</p>
          <p>立即下载APP了解更多</p>
        </div>
        <div class="go" @click="go">立即下载APP</div>
      </div>
    </div>
  </app-main>
</template>

<script>
import AppMain from '../layouts/Main';
import AppHeader from '../layouts/Header';
import getters from '../../store/module/user';
import FamousHeader from './components/FamousHeader';
import { collectCelebrity, sendMsg, checkOur, inputImg, settledData, inputImgs } from "../../request/api";
export default {
  name: "Report",
  components: {
    AppMain, AppHeader, FamousHeader
  },
  data() {
    return {
      inputName: "",
      inputPhone: "",
      inputVerification: "",
      textareaValue: '',
      isshow: false,
      isknow: false,
      photoImgList: null,
      photoImg: null,
      imagesUri: '',
      ProductionImgList: [],
    }
  },

  methods: {
    submit() {
      let that = this
      settledData({
        name: that.inputName,
        professor: that.inputVerification,
        mobile: that.inputPhone,
        achievement: that.textareaValue,
        photo: that.photoImgList,
        opus_urls: that.imagesUri
      }).then((res) => {
        console.log(res.code);
        if (res.code === 0) {
          that.isshow = true

        }
      });
    },
    go() {
      let that = this
      that.isshow = false
    },
    addPhoto() {
      var that = this
      let formData = new FormData();
      formData.append('file[]', this.$refs.photoimg.files[0])
      this.upload(formData)
    },
    upload(data) {
      let that = this
      inputImgs(
        data
      ).then((res) => {
        console.log(res.data[0]);
        that.photoImgList = 'https://res.jaadee.net/' + res.data[0]
      })
    },
    addProduction() {
      var that = this
      let formData = new FormData();
      formData.append('file[]', this.$refs.Productionimg.files[0])
      this.uploads(formData)
    },
    uploads(data) {
      let that = this
      inputImgs(
        data
      ).then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          that.ProductionImgList.push('https://res.jaadee.net/' + res.data[i])
        }
        if (that.ProductionImgList.length > 9) {
          that.ProductionImgList = that.ProductionImgList.splice(9, 9)
        }
        that.imagesUri = that.ProductionImgList.join(",")
      })
    },
    remove(index) {
      var that = this
      that.ProductionImgList.splice(index, 1)
    },
    go() {
      let that = this
      that.isshow = false
      this.$JD.router({
        url: "https://app.jaadee.com/do.php?canal=app&fp=RN&uid=",
        isHttps: true,
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.FamousContent {
  background: #36211f;
  padding-bottom: 0.21rem;
  .applyEnter {
    .applyInputText {
      width: 1.23rem;
      height: 0.27rem;
      font-size: 0.19rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(246, 211, 119, 1);
      line-height: 0.27rem;
      text-align-last: justify;
    }
    input::-webkit-input-placeholder {
      color: #9f8149;
      font-size: 0.19rem;
    }
    textarea::-webkit-input-placeholder {
      color: #9f8149;
      font-size: 0.19rem;
    }
    .applyInformation {
      margin: 0 0.16rem 0.34rem 0.16rem;
      width: 4.68rem;
      min-height: 10.65rem;
      background: rgba(81, 59, 48, 1);
      border-radius: 0.08rem;
      .applyInformationList {
        margin: 0 0.16rem;
        .applyName {
          display: flex;
          flex-direction: row;
          align-items: center;
          height: 0.8rem;
          border-bottom: 0.01rem solid #8e6d5c;
          input {
            line-height: 0.6rem;
            border: none;
            background: rgba(81, 59, 48, 1);
            color: #f6d377;
          }
          .applyVerify {
            width: 1.02rem;
            height: 0.35rem;
            background: linear-gradient(
              267deg,
              rgba(213, 175, 112, 1) 0%,
              rgba(170, 119, 61, 1) 100%
            );
            border-radius: 0.5rem;
            font-size: 0.19rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(89, 56, 1, 1);
            line-height: 0.35rem;
          }
        }
        .applyPhone {
          display: flex;
          flex-direction: row;
          align-items: center;
          height: 0.8rem;
          border-bottom: 0.01rem solid #8e6d5c;
          input {
            line-height: 0.6rem;
            border: none;
            background: rgba(81, 59, 48, 1);
            color: #f6d377;
          }
          .applysend {
            width: 1.17rem;
            height: 0.35rem;
            background: #f0d7af;
            border-radius: 0.5rem;
            font-size: 0.19rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(89, 56, 1, 1);
            line-height: 0.35rem;
            margin-left: 0.1rem;
          }
        }
        .applyVerification {
          display: flex;
          flex-direction: row;
          align-items: center;
          height: 0.8rem;
          border-bottom: 0.01rem solid #8e6d5c;
          input {
            line-height: 0.6rem;
            border: none;
            background: rgba(81, 59, 48, 1);
            color: #f6d377;
          }
        }
        .applyArt {
          .applyInputText {
            margin: 0.26rem 0 0.11rem 0;
          }
          .applyArtTextBox {
            position: relative;
            .applyArtText {
              width: 4.41rem;
              height: 2.13rem;
              background: rgba(72, 51, 40, 1);
              color: rgba(89, 56, 1, 1);
              border-radius: 0.05rem;
              border: none;
              resize: none;
              color: #f6d377;
              padding: 0.21rem 0.16rem;
            }
            .textNumber {
              width: 0.47rem;
              height: 0.22rem;
              font-size: 0.16rem;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #9f8149;
              line-height: 0.22rem;
              text-align: right;
              position: absolute;
              bottom: 0.05rem;
              right: 0;
            }
          }
        }
        .applyPhoto {
          .applyInputText {
            margin: 0.26rem 0 0.11rem 0;
          }
          .PhotoList {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            .PhotoItem {
              width: 1.37rem;
              height: 1.37rem;
              margin: 0.04rem;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .addPhoto {
              width: 1.37rem;
              height: 1.37rem;
              border-radius: 0.02rem;
              border: 0.01rem solid rgba(205, 167, 118, 1);
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              position: relative;
              margin-top: 0.04rem;

              .filePrew {
                width: 1.47rem;
                height: 1.47rem;
                position: absolute;
                opacity: 0;
              }
              .photoImg {
                width: 0.48rem;
                height: 0.49rem;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
              .photoText {
                width: 1.07rem;
                height: 0.19rem;
                font-size: 0.16rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(205, 167, 118, 1);
                line-height: 0.19rem;
              }
            }
          }
        }
        .applyProduction {
          .applyInputText {
            width: 1.41rem;
            margin: 0.43rem 0 0.11rem 0;
          }
          .mail {
            // width: 3.61rem;
            // height: 0.23rem;
            background: rgba(170, 119, 61, 1);
            position: relative;
            padding: 0.05rem;
            border-radius: 0.5rem;
            margin-bottom: 0.15rem;
            .mailText {
              // height: 0.22rem;
              font-size: 0.16rem;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(232, 213, 183, 1);
              line-height: 0.22rem;
            }
            .sj {
              position: absolute;
              left: 0.2rem;
              width: 0;
              height: 0;
              border: 0.1rem solid transparent;
              border-top-color: rgba(170, 119, 61, 1);
            }
          }
          .ProductionList {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            padding-bottom: 0.45rem;
            .ProductionItem {
              width: 1.37rem;
              height: 1.37rem;
              margin: 0.04rem;
              position: relative;
              .remove {
                width: 0.21rem;
                height: 0.21rem;
                position: absolute;
                right: 0;
                top: 0;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
              img {
                width: 100%;
                height: 100%;
              }
            }

            .addProduction {
              width: 1.37rem;
              height: 1.37rem;
              border-radius: 0.02rem;
              border: 0.01rem solid rgba(205, 167, 118, 1);
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              position: relative;
              margin-top: 0.04rem;

              .filePrew {
                width: 1.37rem;
                height: 1.37rem;
                position: absolute;
                opacity: 0;
              }
              .ProductionImg {
                width: 0.48rem;
                height: 0.49rem;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
              .ProductionText {
                width: 1.07rem;
                height: 0.19rem;
                font-size: 0.16rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(205, 167, 118, 1);
                line-height: 0.19rem;
              }
            }
          }
        }
      }
    }
  }
  .contacts {
    width: 4.68rem;
    height: 1.33rem;
    background: rgba(81, 59, 48, 1);
    border-radius: 0.11rem;
    margin: 0 0.16rem 0.34rem 0.16rem;
    .contactsText {
      padding: 0.32rem 0.2rem;
      text-align: left;
      font-size: 0.19rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(232, 213, 183, 1);
      line-height: 0.35rem;
    }
  }
  .submit {
    width: 4.68rem;
    height: 0.59rem;
    background: linear-gradient(
      270deg,
      rgba(212, 174, 112, 1) 0%,
      rgba(171, 120, 62, 1) 100%
    );
    border-radius: 0.29rem;
    margin: 0 0.16rem;
    text-align: center;
    line-height: 0.59rem;
    font-size: 0.24rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bolder;
    color: rgba(89, 56, 1, 1);
  }
  .goDown {
    position: fixed;
    top: 3.88rem;
    left: 0.57rem;
    width: 3.87rem;
    height: 2.16rem;
    background: rgba(255, 255, 255, 1);
    border-radius: 0.12rem;
    .Downtext {
      margin: 0.21rem 0 0 0;
      font-size: 0.19rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 0.5rem;
    }
    .go {
      margin-left: 0.39rem;
      width: 3.07rem;
      height: 0.51rem;
      background: rgba(0, 102, 34, 1);
      border-radius: 0.25rem;
      text-align: center;
      line-height: 0.51rem;
      color: #ffffff;
    }
  }
  .isnot {
    position: fixed;
    top: 3.88rem;
    left: 0.57rem;
    width: 3.87rem;
    height: 2rem;
    background: rgba(255, 255, 255, 1);
    border-radius: 0.12rem;
    .isnotText {
      margin: 0.21rem 0.5rem;
      font-size: 0.19rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 0.5rem;
    }
    .know {
      margin-left: 0.39rem;
      width: 3.07rem;
      height: 0.51rem;
      background: rgba(0, 102, 34, 1);
      border-radius: 0.25rem;
      text-align: center;
      line-height: 0.51rem;
      color: #ffffff;
    }
  }
}
</style>